export const DEFAULT_HEADER = "Hello!!!";
export const DEFAULT_TEXT = "I'm super toast!";
